import React, { useState, useRef, useEffect, useContext } from "react";
import { SelectProductContainer } from "./SelectProductStyled";

import dropDownPink from './../../utils/images/arrow_down_pink.svg';
import dropDownPinkUp from './../../utils/images/arrow_down_pink_up.svg';

import { FormattedMessage } from 'react-intl';
import { useNavigate } from "react-router-dom";
import Product from "./Product";
import { UserContext } from "../../context/userContext";
import ModalAddProduct from "../ModalAddProduct/ModalAddProduct";

export default function SelectProduct({ /* products, */ onSelect, selectedProduct, setSelectedProduct }) {

    const selectRef = useRef(null);
    const navigate = useNavigate();
    const { userType, products } = useContext(UserContext);

    const [showProductOptions, setShowProductOptions] = useState(false);
    //const [productSelected, setProductSelected] = useState();
    const [showAddProduct, setShowAddProduct] = useState(false);
    const [productsOptions, setProductsOptions] = useState([]);

    useEffect(() => {

        function handleClickOutside(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setShowProductOptions(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [selectRef])

    useEffect(() => {
        const auxProducts = []
        products.map((product) => {
            auxProducts.push({ label: product.name, value: product.id, price: product.price?.USD, image: product.image })
        })
        setProductsOptions(auxProducts)
    }, [products, showAddProduct])

    return (
        <SelectProductContainer ref={selectRef}>

            {/*   <div className="selectContainer" ref={selectRef}> */}
            <div className="select" id="select" onClick={() => setShowProductOptions(!showProductOptions)}>
                <div className="selected" >

                    {(selectedProduct === undefined) ? (<p><FormattedMessage id="create_collaboration_select" defaultMessage="Selecciona tu producto/campaña" /><span className="required"> *</span></p>) : (<p>{selectedProduct.label}</p>)}

                </div>

                <img src={(showProductOptions) ? dropDownPinkUp : dropDownPink} alt="down" className="dropdown" onClick={() => setShowProductOptions(!showProductOptions)} />
            </div>
            <p className="required">*<FormattedMessage id="create_collaboration_select_required" defaultMessage="Login requerido" /></p>
            {
                (showProductOptions) && (
                    <div className="options" id="options">
                        {(productsOptions.map((product, index) => {

                            return (
                                <div className="option" key={index} onClick={() => {
                                    setSelectedProduct(product)
                                    setShowProductOptions(false)
                                    onSelect(product)
                                }}>
                                    {/*  <div className="product">
                                        <p className="productName">{product.label}</p>
                                        <img src={product.image} alt="product" className="productImage" />
                                        <p className="productPrice">USD {product.price}</p>
                                    </div> */}
                                    <Product data={product} />

                                </div>
                            )
                        }
                        ))}
                        {(userType === 'company') && (<div className="add">
                            <p className="addText" onClick={() => {
                                //navigate('/myprofile') 

                                setShowAddProduct(true);
                            }}><FormattedMessage id="create_collaboration_select_add" defaultMessage="Añadir nuevo producto" /></p>
                            <p className="plus">+</p>
                        </div>
                        )}

                    </div>
                )
            }
            {/* </div> */}

            {(showAddProduct) && (<ModalAddProduct setShowAddProduct={setShowAddProduct} />)}

        </SelectProductContainer>
    )
}